import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { DateTime } from "./DateTime";

export const DateTimeFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <DateTime identifier={input?.name} input={input} fieldAttr={fieldAttr} />
        </Input>
    );
};
